"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["grayscale", "href", "className", "src", "alt", "target"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".Image__link {\n  text-decoration: none;\n  color: #424242;\n}\n.Image__grayscale {\n  filter: grayscale(1);\n  transition: all 0.15ms ease-in-out;\n}\n.Image__grayscale:hover {\n  filter: grayscale(0);\n}";
  var fileName = "Image_Image";
  var element = document.querySelector("style[data-sass-component='Image_Image']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Image = function Image(_ref) {
  var grayscale = _ref.grayscale,
    href = _ref.href,
    className = _ref.className,
    src = _ref.src,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'Image' : _ref$alt,
    target = _ref.target,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var formattedClassName = "Image".concat(grayscale ? '__grayscale' : '', " ").concat(className || '');
  if (href) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      className: "Image__link",
      href: href,
      target: target,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread({
        className: formattedClassName,
        src: src,
        alt: alt
      }, rest))
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread({
    className: formattedClassName,
    src: src,
    alt: alt
  }, rest));
};
var _default = Image;
exports["default"] = _default;